module.exports = __webpack_public_path__ + "img/chilim-smoke.5aa0d78e.png";